enum AddressResidentialStatus {
  TENANT
  OWNER_OCCUPIER
  LIVING_WITH_FAMILY
  CORRESPONDENCE_ONLY
  INVALID_RESIDENTIAL_STATUS
}

interface AddressFields {
  line_1: String
  line_2: String
  line_3: String
  town: String
  county: String
  postcode: String
  country: String
}

type AddressSummary {
  id: ID!
  count: Int!
  summary: String!
  location: String!
}

type Address implements AddressFields {
  line_1: String
  line_2: String
  line_3: String
  town: String
  county: String
  postcode: String
  country: String
}

type ClientAddress {
  id: String
  internalHash: String
  address: LutherAddress!
  is_current_correspondence: Boolean
  move_in_date: String
  move_out_date: String
  residential_status: AddressResidentialStatus
  documents: [ID]
  document_verifies: Boolean
  property_location: PropertyLocation
}

input ClientAddressInput {
  id: String
  internalHash: String
  address: LutherAddressInput!
  is_current_correspondence: Boolean
  move_in_date: String
  move_out_date: String
  residential_status: AddressResidentialStatus
  documents: [ID]
  document_verifies: Boolean
  property_location: PropertyLocation
}

input AddressInput {
  line_1: String
  line_2: String
  line_3: String
  town: String
  county: String
  postcode: String
  country: String
}

type LutherAddress {
  address1: String
  address2: String
  address3: String
  posttown: String
  postcode: String
  country: String
  county: String
  acre_property_id: String
}

input LutherAddressInput {
  address1: String
  address2: String
  address3: String
  posttown: String
  postcode: String
  country: String
  county: String
  acre_property_id: String
}

type PropertyStub {
  property_id: Int
  Lat: Float
  Long: Float
}

type PropertyFieldUpdates {
  property_tenure: PropertyTenure
  property_type: String
  property_sub_type: String
  price_paid: Int
  year_built: Int
  property_location: String
  bedrooms: Int
  floor_number: Int
  storeys: Int
  current_energy_rating: String
}

type AddressAndFieldUpdates implements AddressFields {
  line_1: String
  line_2: String
  line_3: String
  town: String
  county: String
  postcode: String
  country: String
  field_updates: PropertyFieldUpdates
  property_id: Int
}
